import type { ReactNode } from "react"
import { createElement } from "react"
import NestedLinkAtm from "@onestore/hel/dist/components/atoms/NestedLinkAtm"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import { Text } from "@ionos-web-design-system/react"
import type { Components } from "react-markdown"

export const sectionParagraphText: Components = {
  p: ({ children }: { children: ReactNode }) =>
    createElement(PushOrg, { bottomSpace: 1, children }),
  strong: ({ children }: { children: ReactNode }) =>
    createElement(Text, { variant: "body", weight: "bold" }, children),
  a: (({ href, children }: { href?: string; children: ReactNode }) =>
    createElement(NestedLinkAtm, {
      href,
      openInNewTab: true,
      title: href ?? "",
      children,
    })) as Components["a"],
} as Components
